module.exports = "/_next/static/images/2acd2a2288a87914a8d7a97389b5b854-pay-yourself-xs@2x.jpg.webp";